<template>
    <div>
        <CommonPopupFrame :changeHeight="75" :closeCompleteAction="closeAction" :isOpen="isOpen" :changeBottom="0" :is-back-press-apply="true">
            <div style="height:76px; border-bottom: 1px solid #ebebeb;">
                <div style="width: 36px; height: 5px; background-color: rgb(217, 217, 217); margin: 5px auto 0px; border-radius: 5px;"></div>
                <div style="margin-top: 14px; position: relative; display: flex; align-items: center;">
                    <div @click="closeAction" style="padding:0px 7px; position: relative;">
                        <img style="width: 42px" :src="require('@/assets/img/recent_x_btn.png')" alt="" />
                    </div>
                    <div style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700">{{ title }}</div>
                </div>
            </div>
            <div style="flex:1;overflow-y: scroll;" @touchmove.stop="() => { }">
                <div>
                    <div @click="setSelectReportReason(each)" :style="{ backgroundColor: selectReportReason === each ? '#f5f5f5' : '#fff' }" style="transition: all 0.3s; padding: 18px 12px; flex: 1; font-weight: 500; font-size: 14px;" v-for="each, i in reports" :key="i">
                        <div style="line-height: 24px;">{{ each }}</div>
                        <div style="margin-top: 8px;" v-if="each === reports[5] && selectReportReason === reports[5]">
                            <input v-model="directInput" placeholder="신고 사유 직접 입력" class="report_input" ref="report" type="text">
                        </div>
                    </div>
                </div>
            </div>
            <div style="height: 93px; padding: 0 12px;">
                <div @click="submitReport" class="common_btn" :class="selectReportReason === '' ? 'un_active' : 'active'" style="">제출하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from "../modal/my/CommonPopupFrame";
import { REPORT_TYPE_NAME } from "../../Constants";
import ResponseCode from "@/ResponseCode"

export default {
    name: "SoccerHowWriteFormPopup",
    components: { CommonPopupFrame },
    props: {
        target_member_idx: {
            type: String,
            default: '-1',
        },
        target_member_type: {
            type: String,
            default: '-1',
        },
        refer_idx: {
            type: [String, Number],
            default: '-1',
        },
        refer_type: {
            type: Number,
            default: -1,
        },
        report_title: {
            type: String,
            default: '',
        },
        report_contents: {
            type: String,
            default: '',
        },
        reportType: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: '피드 신고하기'
        }
    },
    data() {
        return {
            isOpen: false,
            REPORT_TYPE_NAME: REPORT_TYPE_NAME,
            reports: [
                '광고성 게시물',
                '도배성, 반복적인 게시물',
                '부적절한 게시물(분쟁, 정치, 협박, 범죄 등)',
                '욕설 / 비난',
                '허위 사실 유포',
                '신고 사유 직접 입력'
            ],
            selectReportReason: '',
            directInput: ''
        }
    },
    methods: {
        closeAction() {
            if (this.isOpen) {
                this.isOpen = false;
                return;
            }
            setTimeout(() => {
                this.$GlobalStore.closeLastModal();
            }, 300)
        },
        ActBeforeClose() {
            this.isOpen = false;
        },
        setSelectReportReason(reason) {
            this.selectReportReason = reason
            if (reason === this.reports[5]) {
                this.$nextTick(() => {
                    this.$refs.report[0].focus()
                })
            }
        },
        async submitReport() {
            if (this.selectReportReason === '') {
                this.$GlobalStore.showAlert('사유를 선택해주세요.')
                return
            }

            if (this.selectReportReason === this.reports[5] && this.directInput === '') {
                this.$GlobalStore.showAlert('사유를 입력해주세요')
                return
            }
            this.$GlobalStore.showProgress()

            const parameters = {};
            parameters.target_member_idx = this.target_member_idx;
            parameters.target_member_type = this.target_member_type;
            parameters.refer_idx = this.refer_idx;
            parameters.refer_type = this.refer_type;
            parameters.refer_type_name = REPORT_TYPE_NAME[this.refer_type];
            parameters.reason = this.selectReportReason
            parameters.etc = this.directInput;
            parameters.report_title = this.report_title;
            parameters.report_contents = this.report_contents;

            const res = await this.$Axios.post('/api/report/save', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.closeAction()
                this.$GlobalStore.hideProgress()
                this.$GlobalStore.showToastVer2('신고가 접수되었습니다.')
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
                this.$GlobalStore.hideProgress()
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.isOpen = true;
        }, 100)
    },
    created() {
        if (this.reportType === 'training') {
            this.reports = [
                '불편함 및 불쾌감 조성',
                '과한 영업 및 강매',
                '부적절한 정보 포함 (분쟁, 정치, 협박, 범죄 등)',
                '욕설/비난',
            ]
        }
        //this.$GlobalStore.addModal('TestModal', {transitionName : '', isModalBackTransparent : true});
    }
}
</script>

<style scoped>
.common_btn {
    margin-top: 12px;
    text-align: center;
    line-height: 48px;
    height: 48px;
    border-radius: 12px;
    font-weight: 500;
    font-size: 14px;
}

.active {
    background-color: #210f03;
    color: #fff;
}

.un_active {
    background-color: #f5f5f5;
    color: #d9d9d9;
}

.report_input {
    width: 100%;
    border: none;
    border-radius: 12px;
    padding: 12px;
    outline: none;
}

.report_input::placeholder {
    color: #bbbbbb;
    font-size: 14px;
}
</style>